import React from 'react';
import { Link } from 'react-router-dom';
import './PublicFooter.css';

const PublicFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="public-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">decyx</h3>
            <p className="footer-tagline">Digitize asset ownership on the blockchain</p>
          </div>

          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/technology">Technology</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#security">Security</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:support@decyx.com">Support</a></li>
              <li><a href="#documentation">Documentation</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} decyx. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;

